import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

let slowRequestsCount = 0;
const wakingUpListeners = new Set();

export const subscribeToWakingUp = (listener) => {
  wakingUpListeners.add(listener);
  // Initial callback with current state
  listener(slowRequestsCount > 0);
  return () => {
    wakingUpListeners.delete(listener);
  };
};

const notifyWakingUp = (isWaking) => {
  wakingUpListeners.forEach((listener) => {
    try {
      listener(isWaking);
    } catch (e) {
      console.error("Error in waking up listener:", e);
    }
  });
};

const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const isPortalAdmin = typeof window !== "undefined" && (window.location.pathname.startsWith("/portal-admin") || (config.url && config.url.includes("/admin/")));
  const padminToken = localStorage.getItem("ame_padmin_token");
  const userToken = localStorage.getItem("ame_token");
  const token = isPortalAdmin ? (padminToken || userToken) : (userToken || padminToken);

  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Set up tracking for waking up detection if NOT on the landing page "/"
  const isLandingPage = typeof window !== "undefined" && window.location.pathname === "/";
  if (!isLandingPage) {
    config.metadata = { startTime: new Date(), isSlow: false };
    config.wakeupTimeout = setTimeout(() => {
      config.metadata.isSlow = true;
      slowRequestsCount++;
      if (slowRequestsCount === 1) {
        notifyWakingUp(true);
      }
    }, 1500);
  }

  return config;
});

api.interceptors.response.use(
  (response) => {
    const config = response.config;
    if (config) {
      if (config.wakeupTimeout) {
        clearTimeout(config.wakeupTimeout);
      }
      if (config.metadata?.isSlow) {
        slowRequestsCount = Math.max(0, slowRequestsCount - 1);
        if (slowRequestsCount === 0) {
          notifyWakingUp(false);
        }
      }
    }
    return response;
  },
  (error) => {
    const config = error.config;
    if (config) {
      if (config.wakeupTimeout) {
        clearTimeout(config.wakeupTimeout);
      }
      if (config.metadata?.isSlow) {
        slowRequestsCount = Math.max(0, slowRequestsCount - 1);
        if (slowRequestsCount === 0) {
          notifyWakingUp(false);
        }
      }
    }

    if (error.response?.status === 401) {
      const url = config?.url || "";
      // Do not hard-redirect if the 401 is from a login or register attempt
      if (!url.includes("/auth/login") && !url.includes("/auth/register")) {
        if (url.startsWith("/public-admin/") || (typeof window !== "undefined" && window.location.pathname.startsWith("/portal-admin"))) {
          localStorage.removeItem("ame_padmin_token");
          localStorage.removeItem("ame_padmin_user");
          if (typeof window !== "undefined" && window.location.pathname !== "/portal-admin/login") {
            window.location.href = "/portal-admin/login";
          }
        } else if (url.startsWith("/public/")) {
          localStorage.removeItem("ame_public_token");
          if (typeof window !== "undefined" && window.location.pathname !== "/public-login") {
            window.location.href = "/public-login";
          }
        } else {
          localStorage.removeItem("ame_token");
          if (typeof window !== "undefined" && window.location.pathname !== "/login") {
            window.location.href = "/login";
          }
        }
      }
    }
    console.error("API Error:", {
      message: error.message,
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      data: error.response?.data
    });
    return Promise.reject(error);
  }
);

export default api;

